import React from 'react';
import ProfileMenu from './ProfileMenu';
import { URL } from '../variables';
import { connect } from 'react-redux';


class Header extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="topbar" id="header_page" style={{position:this.props.sala_screen==true?'absolute':'fixed'}}>

                <div className="topbar-left" style={{ background: '#ececf1' }}>
                    {this.props.faculdade.logo != null && <a className="logo">
                        <span>
                            <img src={this.props.faculdade.logo} alt="" height='70' />
                        </span>
                        <i>
                            <img className="img-fluid" src={this.props.faculdade.logo} alt="" style={{height:70,objectFit:'contain'}} />
                        </i>
                    </a>}
                </div>
                <nav className="navbar-custom">
                    <ul className="navbar-right d-flex list-inline float-right mb-0">
                        <ProfileMenu />


                    </ul>



                </nav>
            </div>

        );
    }


}

const mapsStateToProps = (state) => (
    {
        faculdade: state.AppReducer.faculdade,
    sala_screen: state.AppReducer.sala_screen,

    }
);

export default connect(mapsStateToProps, {})(Header);